import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';

const initialState: GoodState = {
    active: { Meta: { Page: 0, ResultsPerPage: 20, TotalPages: 0, TotalResults: 0 }, Results: [] },
    archived: { Meta: { Page: 0, ResultsPerPage: 20, TotalPages: 0, TotalResults: 0 }, Results: [] },
    goods: [],
    viewing_id: null,
    viewing_containers: [],
    viewing_transports: [],
};

const rootState: GoodState = initialState;

const getters: GetterTree<GoodState, RootState> = {
    active(state: GoodState): FvgGoodSearchResults | undefined {
        return state.active;
    },
    archived(state: GoodState): FvgGoodSearchResults | undefined {
        return state.archived;
    },
    viewing(state: GoodState): FvgGood | undefined {
        return state.goods.find((good) => good.Id === state.viewing_id);
    },
    containers(state: GoodState): FvgContainer[] {
        return state.viewing_containers;
    },
    transports(state: GoodState): FvgTransport[] {
        return state.viewing_transports;
    },
};

const mutations: MutationTree<GoodState> = {
    SET_GOODS(state: GoodState, goods: FvgGood[]) {
        state.goods = goods;
    },
    SET_VIEWING(state: GoodState, id: number) {
        state.viewing_id = id;
    },
    SET_ACTIVE(state: GoodState, goods: FvgGoodSearchResults) {
        state.active.Meta = goods.Meta;
        // @ts-ignore
        state.active.Results = state.active.Results.concat(goods.Results);
    },
    SET_VIEWING_CONTAINERS(state: GoodState, containers: FvgContainer[]) {
        state.viewing_containers = containers;
    },
    SET_VIEWING_TRANSPORTS(state: GoodState, transports: FvgTransport[]) {
        state.viewing_transports = transports;
    },
    RESET(state: GoodState) {
        Object.assign(state, initialState);
    },
};

const actions: ActionTree<GoodState, RootState> = {
    read({ commit }, id: number): any {
        // @ts-ignore
        return this._vm.$api.get(`goods/${id}`)
            .then((data: ApiResponseGood) => {
                commit('SET_GOODS', [data.data]);
                commit('SET_VIEWING', data.data.Id);
                return Promise.resolve(data.data);
            })
            .catch((e: any) => {
                return Promise.reject([e.response.data]);
            });
    },
    readActive({ commit }, page: number): any {
        if (!page) {
            page = 1;
        }
        // @ts-ignore
        return this._vm.$api.get(`goods?status=active&page=${page}`)
            .then((data: ApiResponseFile) => {
                commit('SET_ACTIVE', data.data);
                return Promise.resolve(data.data);
            })
            .catch((e: any) => {
                return Promise.reject([e.response.data]);
            });
    },
    readTransports({ commit }, id: number): any {
        // @ts-ignore
        return this._vm.$api.get(`goods/${id}/transports`)
            .then((data: ApiResponseTransport) => {
                commit('SET_VIEWING_TRANSPORTS', data.data);
                return Promise.resolve(data.data);
            })
            .catch((e: any) => {
                return Promise.reject([e.response.data]);
            });
    },
    readContainers({ commit }, id: number): any {
        // @ts-ignore
        return this._vm.$api.get(`goods/${id}/containers`)
            .then((data: ApiResponseContainer) => {
                commit('SET_VIEWING_CONTAINERS', data.data);
                return Promise.resolve(data.data);
            })
            .catch((e: any) => {
                return Promise.reject([e.response.data]);
            });
    },
};

export default {
    namespaced: true,
    state: rootState,
    getters,
    actions,
    mutations,
};
